
import { Prop, Watch } from 'vue-property-decorator';
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/Model';

@Options({})
export default class editSingleGLayerModal extends Vue {

    @Prop() productionProcessName: string;
    @Prop() emissionCalculation: OM.SingleGModel;
    @Prop() saveCallback: (updatedModel: OM.SingleGModel) => void;

    localModel = new OM.SingleGModel();

    created() {
        this.localModel = this.emissionCalculation;
    }

    get disabled(){
        return !this.localModel.grams.value;
    }

    save() {
        this.saveCallback(this.localModel);
    }
}
